import API from "../api/apiUser";

/**
 * Service for fetching public gallery data (Images & Videos).
 */
export const UserGalleryService = {
    /**
     * Fetches all active gallery images.
     * @returns {Promise<Array>} List of image objects.
     */
    getImages: async () => {
        try {
            const response = await API.get("/user/gallery/images");
            return response.data;
        } catch (error) {
            console.error("Error fetching gallery images:", error);
            throw error;
        }
    },

    /**
     * Fetches all active ready gallery videos.
     * @returns {Promise<Array>} List of video objects.
     */
    getVideos: async () => {
        try {
            const response = await API.get("/user/gallery/videos");
            return response.data;
        } catch (error) {
            console.error("Error fetching gallery videos:", error);
            throw error;
        }
    },

    /**
     * Triggers a download of the press photos ZIP.
     */
    downloadPhotos: async () => {
        try {
            // Using a direct download approach as it's a file stream
            const response = await API.get("/user/gallery/download-photos", {
                responseType: 'blob'
            });

            // Create a link and trigger click
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'temidayo_balogun_press_photos.zip');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error downloading photos:", error);
            throw error;
        }
    }
};
